<template>
  <div class="profile-container">
    <div class="tab-header">
      {{ this.$t("menu_my_profile") }}
    </div>

    <!-- 头像部分 -->
    <div class="profile-section">
      <div class="avatar-section">
        <div class="avatar-label-wrapper">
          <label class="section-nickname-label">{{this.$t("profile_avatar_title_with_colon")}}</label>
          <button class="avatar-button" @click="showChangeAvatar">
            <img :src="user.avatar" class="avatar-image" alt="User Avatar">
          </button>
        </div>
      </div>
    </div>


    <!-- 头像选择对话框 -->
    <div v-if="showAvatarDialog" class="avatar-dialog-overlay">
      <div class="avatar-dialog">
        <div class="avatar-dialog-label">{{this.$t("profile_select_avatar_title")}}</div>
        <div class="avatar-options">
          <div
            v-for="(avatar,index) in avatarOptions"
            :key="index"
            class="avatar-option"
            :class="{ 'selected': selectedAvatar === avatar.key }"
            @click="selectAvatar(avatar.key)"
          >
            <img :src="avatar.url" class="avatar-preview">
          </div>
        </div>
        <div class="avatar-dialog-buttons">
          <button class="dialog-btn cancel-btn" @click="cancelAvatarChange">{{this.$t("layout_cancel")}}</button>
          <button class="dialog-btn confirm-btn" @click="confirmAvatarChange">{{this.$t("layout_confirm")}}</button>
        </div>
      </div>
    </div>

    <!-- 昵称部分 -->
    <div class="profile-section">
      <div class="nickname-section" style="display: flex; align-items: center;">
        <label class="section-nickname-label">{{this.$t("profile_nickname_title_with_colon")}}</label>
        <!-- 昵称修改对话框 -->
        <!-- 查看模式 -->
        <div v-if="!showDialog" class="nickname-content">
          <span class="nickname-text">{{ user.nickname }}</span>
          <button class="edit-nickname-btn" @click="showNicknameDialog">{{this.$t("layout_modify")}}</button>
        </div>
        <!-- 编辑模式 -->
        <div v-else class="nickname-edit-container">
          <div class="input-group">
            <el-input
              v-model="newNickname"
              :placeholder="this.$t('profile_need_nickname')"
              @keyup.enter="confirmNickname"
              ref="nicknameInput"
            ></el-input>
            <span class="validation-text">{{this.$t("profile_transact_sql_injection_rules")}}</span>
          </div>
          <div class="dialog-buttons">
            <button class="dialog-btn cancel-btn" @click="cancelNickname">{{this.$t("layout_cancel")}}</button>
            <button class="dialog-btn confirm-btn" @click="confirmNickname">{{this.$t("layout_confirm")}}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 自定义分割线 -->
    <div v-if="!isRecipient" class="mira-form-divider">------------------------------------------------------------------------</div>

    <!-- 更改密码部分 -->
    <div v-if="!isRecipient" class="profile-section">
        <div class="nickname-section" style="display: flex; align-items: center;">
          <label class="section-label">{{this.$t("profile_change_password_title_with_colon")}}</label>
          <div class="password-form">
            <div class="form-group">
              <el-input v-model="passwordForm.oldPassword" size="medium" show-password :placeholder="this.$t('profile_need_old_password')" ></el-input>
            </div>
            <div class="form-group">
              <el-input v-model="passwordForm.newPassword" size="medium" show-password :placeholder="this.$t('profile_need_new_password')" ></el-input>
            </div>
            <div class="form-group">
              <el-input v-model="passwordForm.confirmPassword" size="medium" show-password :placeholder="this.$t('profile_need_confirm_password')" ></el-input>
            </div>
            <button class="submit-btn" @click="updatePassword">{{this.$t("layout_confirm")}}</button>
          </div>
        </div>
    </div>

    <!-- 自定义分割线 -->
    <div v-if="!isRecipient" class="mira-form-divider">------------------------------------------------------------------------</div>

    <!-- 更改邮箱部分 -->
    <div v-if="!isRecipient" class="profile-section">
        <div class="nickname-section" style="display: flex; align-items: center;">
          <label class="section-label">{{this.$t("profile_change_email_title_with_colon")}}</label>
          <div class="email-form">
            <div class="form-group">
              <el-input v-model="emailForm.currentEmail" disabled> </el-input>
            </div>
            <div class="form-group">
              <el-input v-model="emailForm.newEmail"
                     :placeholder="this.$t('profile_need_new_email')" ></el-input>
            </div>
            <div class="form-group">
              <div class="verification-code-group">
                <el-input v-model="emailForm.verifycode"
                       :placeholder="this.$t('profile_need_verification_code')"></el-input>
                <button class="send-verification-btn" @click="sendVerificationCode">{{this.$t("profile_layout_send_verification_code")}}</button>
              </div>
            </div>
            <button class="submit-btn" @click="updateEmail">{{this.$t("layout_confirm")}}</button>
          </div>
        </div>
    </div>

  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import * as auth from "@/api/platform/auth";
import * as user from "@/api/tcode/user";
import * as cache from "@/utils/cache";
import {changeAvatar, changeDisplayName, changePassword} from "../../../api/platform/auth";
import { setup } from "../../../locales";
export default {
  name: 'ProfilePage',
  data() {
    return {
      // 原有数据保持不变...
      showAvatarDialog: false,
      selectedAvatar: '',
      avatarOptions: [
        { key: "avatar1", url: require("@/assets/avatar/avatar1.png") },
        { key: "avatar2", url: require("@/assets/avatar/avatar2.png") },
        { key: "avatar3", url: require("@/assets/avatar/avatar3.png") }
      ],
      avatarOptions2: [
        { key: "avatar1", url: "@/assets/avatar/avatar1.png" },
        { key: "avatar2", url: "@/assets/avatar/avatar2.png" },
        { key: "avatar3", url: "@/assets/avatar/avatar3.png" }
      ],
      user: {
        avatar: require("@/assets/avatar/default-avatar.png"), // 默认头像路径
        nickname: '',
      },
      showDialog: false,
      newNickname: '',
      verificationCode: '',
      nicknameForm: {
        name: '',
        pk: '',
      },
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        from: '',
        pwd: '',
        id: '',
      },
      emailForm: {
        currentEmail: '', // 示例当前邮箱
        newEmail: '',
        verifycode: '',
        logincode: '',
        id: '',
      }
    }
  },
  computed: {
    userInfo: function () {
       return cache.getUserInfo();
    },
    isRecipient() {
      return (this.userInfo.loginMedthod !== 'Email');
    }
  },
  methods: {
    showChangeAvatar() {
      this.selectedAvatar = this.userInfo.avatar;
      this.showAvatarDialog = true;
    },
    selectAvatar(avatar) {
      this.selectedAvatar = avatar;
    },
    cancelAvatarChange() {
      this.showAvatarDialog = false;
    },
    getUrlByKey(key) {
      if ("avatar1".endsWith(key)){

        this.user.avatar = require("@/assets/avatar/avatar1.png");
      } else if ("avatar2".endsWith(key)) {
        this.user.avatar = require("@/assets/avatar/avatar2.png");
      } else if ("avatar3".endsWith(key)) {
        this.user.avatar = require("@/assets/avatar/avatar3.png");
      } else {
        this.user.avatar = require("@/assets/avatar/default-avatar.png");
      }
    },
    getUrlByKey2(key) {
      // 1. 检查字符串是否为空
      if (!key || typeof key !== 'string') {
        this.user.avatar = require("@/assets/avatar/default-avatar.png");
      }
      // 2. 查找最后一个斜杠的位置
      const lastSlashIndex = key.lastIndexOf('/');
      if (lastSlashIndex === -1) {
        this.user.avatar = require("@/assets/avatar/default-avatar.png");
      }
      // 3. 获取最后一个斜杠后的部分
      const lastPart = key.slice(lastSlashIndex + 1);

      if ("avt_1.png".endsWith(lastPart)){
        this.user.avatar = require("@/assets/avatar/avatar1.png");
      } else if ("avt_2.png".endsWith(lastPart)) {
        this.user.avatar = require("@/assets/avatar/avatar2.png");
      } else if ("avt_3.png".endsWith(lastPart)) {
        this.user.avatar = require("@/assets/avatar/avatar3.png");
      } else {
        this.user.avatar = require("@/assets/avatar/default-avatar.png");
      }
    },
    getUserInfo() {
      user.get(this.userInfo.pk).then(result => {
        this.getUrlByKey2(result.data.pk_pic);
        this.user.nickname = result.data.displayName;
        this.emailForm.currentEmail = result.data.email;
      }).catch(error => {
      });
    },
    confirmAvatarChange() {
      if (!this.selectedAvatar) {
        this.$message({type: "error", message: this.$t('profile_select_avatar_warning1')});
        return;
      }
      if (this.selectedAvatar) {
        this.getUrlByKey(this.selectedAvatar)
      }
      auth.changeAvatar({pk:this.userInfo.pk,avatar:this.getUrlByKeyForSave(this.selectedAvatar)}).then(result => {
      }).catch(error => {
      })
      this.showAvatarDialog = false;
    },
    getUrlByKeyForSave(key) {
      if ("avatar1".endsWith(key)){
        return "/data/user/0/com.miraplay.aio/files/accountAvatars/avt_1.png";
      } else if ("avatar2".endsWith(key)) {
        return "/data/user/0/com.miraplay.aio/files/accountAvatars/avt_2.png";
      } else if ("avatar3".endsWith(key)) {
        return "/data/user/0/com.miraplay.aio/files/accountAvatars/avt_3.png";
      }else{
        return "/data/user/0/com.miraplay.aio/files/accountAvatars/avt_default.png";
      }
    },
    showNicknameDialog() {
      this.newNickname = this.user.nickname;
      this.showDialog = true;
      // 下一个tick聚焦输入框
      this.$nextTick(() => {
        this.$refs.nicknameInput.focus();
      });
    },
    cancelNickname() {
      this.showDialog = false;
      // 可选：重置输入内容
      this.newNickname = this.user.nickname;
    },
    confirmNickname() {
      if (this.newNickname.trim() === '') {
        this.$message({type: "error", message: this.$t('profile_need_nickname')});
        return;
      }
      // 验证昵称
      if (!this.validateNickname(this.newNickname)) {
        this.$message({type: "error", message: this.$t('profile_nickname_valid_warning1')});
        return;
      }

      this.nicknameForm.name = this.newNickname;
      this.nicknameForm.pk = this.userInfo.pk;
      auth.changeDisplayName(this.nicknameForm).then(result => {
          this.$message({
          duration: 1500,
          message: this.$t('profile_change_nickname_success'),
          type: 'success'
        });
      }).catch(error => {
      })
      this.user.nickname = this.newNickname;
      this.showDialog = false;
    },
    validateNickname(nickname) {
      // 验证规则：不能包含单引号、分号和双连字符
      const forbiddenChars = ["'", ";", "--"];
      return !forbiddenChars.some(char => nickname.includes(char));
    },
    // 其他方法保
    updatePassword() {
      // 验证密码表单
      if (!this.passwordForm.oldPassword) {
        this.$message({type: "error", message: this.$t('profile_need_old_password')});
        return;
      }
      if (!this.passwordForm.newPassword) {
        this.$message({type: "error", message: this.$t('profile_need_new_password')});
        return;
      }
      if (!this.passwordForm.confirmPassword) {
        this.$message({type: "error", message: this.$t('profile_need_confirm_password')});
        return;
      }
      if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
        this.$message({type: "error", message: this.$t('profile_password_valid_warning1')});
        return;
      }
      if (this.passwordForm.newPassword.length<8 || this.passwordForm.newPassword.length>16) {
        this.$message({type: "error", message: this.$t('profile_password_valid_warning2')});
        return;
      }
      const hashOld = CryptoJS.MD5(this.passwordForm.oldPassword);
      const base64EncodedOld = CryptoJS.enc.Base64.stringify(hashOld);
      this.passwordForm.from = base64EncodedOld;

      const hash = CryptoJS.MD5(this.passwordForm.newPassword);
      const base64Encoded = CryptoJS.enc.Base64.stringify(hash);
      this.passwordForm.pwd = base64Encoded;
      this.passwordForm.id = this.userInfo.pk;

      auth.changePassword(this.passwordForm).then(result => {
        this.$message({
          duration: 1500,
          message: this.$t('profile_change_password_success'),
          type: 'success'
        });
      }).catch(error => {
      })
      // 清空表单
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
    },

    // 发送验证码
    sendVerificationCode () {
      if (!this.emailForm.newEmail) {
        this.$message({type: "error", message: this.$t('profile_need_new_email')});
        return;
      }
      //邮箱格式
      if (!this.validateEmail(this.emailForm.newEmail)){
        this.$message({type: "error", message: this.$t('login_account_valid_warning1')});
        return;
      }
      //验证码
      this.generateVerificationCode(6);

      auth.changeEmailVerifyCodeEmail({pk_user:this.userInfo.pk, mailCode: this.verificationCode, email: this.emailForm.newEmail, language: this.$i18n.locale}).then(result => {
        this.$message({
          duration: 1500,
          message: this.$t('profile_verification_code_warning1')+" "+
            this.$t('profile_verification_code_id')+this.verificationCode+" "+
            this.$t('profile_verification_code_warning3'),
          type: 'success'
        });
      }).catch(error => {
      })
    },
    // 生成验证码
    generateVerificationCode(length) { // 默认长度为6
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      this.verificationCode = result;
    },
    //  更新邮箱
    updateEmail() {
      if (!this.emailForm.newEmail) {
        this.$message({type: "error", message: this.$t('profile_need_new_email')});
        return;
      }
      if (!this.emailForm.verifycode) {
        this.$message({type: "error", message: this.$t('profile_need_verification_code')});
        return;
      }
      this.emailForm.verifycode = this.emailForm.verifycode;
      this.emailForm.logincode = this.emailForm.newEmail;
      this.emailForm.id = this.userInfo.pk;
      auth.changeEmail(this.emailForm).then(result => {
        this.$message({
          duration: 1500,
          message: this.$t('profile_change_email_success'),
          type: 'success'
        });
      }).catch(error => {
      })

      this.emailForm = {
        currentEmail: this.emailForm.newEmail,
        newEmail: '',
        verificationCode: ''
      };
    },
    validateEmail(email) {
      // 正则表达式模式
      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return pattern.test(email);
    },
  },
  // 初始化调用方法
  created () {
    //this.getUrlByKey(this.userInfo.photo);
    this.getUserInfo();
  },
}
</script>

<style scoped>
.tab-header {
  display: inline-flex;
  margin-bottom: 15px;
  padding-top: 20px;
  padding-bottom: 10px;
  ont-family: PingFangSC-Medium;
  font-size: 17px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 500;
}
/* 新增头像对话框样式 */
.avatar-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.avatar-dialog {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  width: 400px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.avatar-dialog h3 {
  margin-top: 0;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-options {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}

.avatar-option {
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  transition: all 0.3s;
}

.avatar-option:hover {
  background-color: #f0f0f0;
}

.avatar-option.selected {
  background-color: #AA81FF20;
  border: 2px solid #AA81FF;
}
/* 新增头像对话框样式 */
.avatar-preview {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  object-fit: cover;
}

.profile-container {
  padding-left: 40px;
  text-align: left; /* 内容左对齐 */
}
.profile-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}
.profile-section {
  margin-bottom: 15px;
}
.avatar-label-wrapper {
  display: flex; /* 使用 flexbox 布局 */
  align-items: center; /* 垂直居中对齐 */
}
.section-nickname-label {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333;
  width: 170px;
  font-weight: 400;
}
.section-label {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333;
  width: 170px;
  font-weight: 400;
}
.avatar-button {
  background: none; /* 去掉按钮背景 */
  border: none; /* 去掉按钮边框 */
  padding: 0; /* 去掉内边距 */
  cursor: pointer; /* 鼠标指针变为手形 */
}
.avatar-image {
  width: 100px; /* 调整头像大小 */
  height: 100px; /* 调整头像大小 */
  border-radius: 4px; /* 保持方形边框 */
  border: 1px solid #8300F6; /* 添加紫色边框，调整粗细 */
  object-fit: cover; /* 保持图片比例 */
}
.nickname-content {
  display: flex;
  align-items: center;
  gap: 15px;
}
.nickname-text {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333;
  margin-right: 30px;
  font-weight: 400;
}
.edit-nickname-btn {
  padding: 0; /* 移除填充 */
  background: none; /* 移除背景 */
  color: #8300F6; /* 使用紫色作为链接颜色 */
  border: none; /* 移除边框 */
  cursor: pointer;
  font-size: 14px;
  transition: color 0.3s;
  margin-left: 10px; /* 调整间距 */
}
.edit-nickname-btn:hover {
  color: #AA81FF; /* 悬停时颜色变浅 */
  border-bottom-color: #AA81FF; /* 悬停时下划线颜色变浅 */
}
/* 新增的对话框样式 */
/* 新增的编辑容器样式 */
.nickname-edit-container {
  display: flex !important; /* 强制覆盖可能的隐藏样式 */
  flex-direction: column;
  gap: 10px;
  width: 300px;
}
.validation-text {
  font-size: 12px;
  color: #666;
  white-space: nowrap; /* 防止文字自动换行 */
}
.dialog-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.dialog-buttons {
  display: flex;
  justify-content: left; /* 水平居左 */
  gap: 30px; /* 加大按钮之间间隔，你可以根据需要调整数值 */
  margin-top: 10px;
}
.avatar-dialog-buttons
{
  display: flex;
  justify-content: center; /* 水平居中 */
  gap: 30px; /* 加大按钮之间间隔，你可以根据需要调整数值 */
  margin-top: 10px;
}
.dialog-btn {
  padding: 8px 35px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-btn {
  background-color: #F4F3F1;
  color: #AA81FF;
  border: 1px solid #AA81FF;
}

.cancel-btn:hover {
  background-color: #e0e0e0;
}

.confirm-btn {
  background-color: #AA81FF;
  color: white;
  border: none;
}

.confirm-btn:hover {
  background-color: #7200D6;
}
/* 密码表单样式 */
.password-form{
  width: 300px;
}
.email-form {
  width: 300px;
}

.password-input,
.email-input {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box; /* 重要：确保 padding 不影响宽度 */
}
.form-group {
  margin-bottom: 15px;
}
.submit-btn {
  padding: 8px 35px;
  background-color: #AA81FF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
  margin-top: 10px;
}

.submit-btn:hover {
  background-color: #7200D6;
}

/* 自定义分割线样式 */
.mira-form-divider {
  text-align: left;
  margin: 10px 0;
  font-size: 16px; /* 字体大小可根据需要调整 */
  color: #979797; /* 字体颜色 */
}

.send-verification-btn {
  padding: 5px 15px;
  background-color: #AA81FF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: background-color 0.3s;
  margin-left: 10px;
  white-space: nowrap; /* 防止换行 */
}

.send-verification-btn:hover {
  background-color: #7200D6;
}
.verification-code-group {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}
.verification-code-group input[type="text"] {
  flex: 1; /* 输入框占据剩余空间 */
}

.content-disabled {
  pointer-events: none; /* 禁用所有鼠标事件 */
  opacity: 0.7; /* 可选：使内容看起来被禁用 */
}
.avatar-dialog-label {
  display: flex; /* 或 block 也可以 */
  justify-content: center; /* 水平居中 */
  width: 100%; /* 确保占据全宽 */
  padding: 10px 0 15px 0;
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 500;
  text-align: center; /* 文本居中 */
}
</style>



// WEBPACK FOOTER //
// src/pages/tcode/myProfile/profile.vue